export default {
    props: {
      value: {
        type: Array,
        default() {
          return []
        }
      },
      type: {
        type: String,
        default: 'default'
      }
    }
  }


/** WEBPACK FOOTER **
 ** ./src/checkboxGroup.vue
 **/